import { DefaultUrlSerializer, UrlTree } from '@angular/router';
import { RoutingPath } from 'mbs-ui-shared@constants';

export class GlobalUrlSerializer extends DefaultUrlSerializer {
  private readonly allowedPaths = Object.values(RoutingPath)
    .filter((value) => value.indexOf('/') !== -1)
    .map((x) => ({ path: x, lower: x.toLowerCase() }))
    .sort((a, b) => b.path.length - a.path.length);

  parse(url: string): UrlTree {
    if (!url || url.indexOf('/') === -1) {
      return super.parse(url);
    }

    const lowerUrl = url.toLowerCase();
    const matched = this.allowedPaths.find((p) => lowerUrl.includes(p.lower));
    const result = matched ? url.replace(new RegExp(matched.lower, 'i'), matched.path) : url;

    return super.parse(result);
  }
}
